<template>
  <transition name="toast-slide">
    <div
      v-if="visible"
      class="app-toast"
      :class="[`app-toast--${type}`, `app-toast--${position}`]"
      role="alert"
    >
      <i :class="icon"></i>
      <span class="app-toast-msg">{{ message }}</span>
      <button type="button" class="app-toast-close" title="Cerrar" aria-label="Cerrar" @click="hide">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'AppToast',
  data() {
    return {
      visible: false,
      message: '',
      type: 'success',
      position: 'bottom',
      timer: null
    };
  },
  computed: {
    icon() {
      const icons = {
        success: 'bi bi-check-circle-fill',
        danger: 'bi bi-x-circle-fill',
        warning: 'bi bi-exclamation-triangle-fill',
        info: 'bi bi-info-circle-fill'
      };
      return icons[this.type] || icons.info;
    }
  },
  mounted() {
    window.addEventListener('app:toast', this.onToast);
  },
  beforeUnmount() {
    window.removeEventListener('app:toast', this.onToast);
    clearTimeout(this.timer);
  },
  methods: {
    isSticky(duration) {
      // 0 / '0' / null / false = no auto-cierre
      return duration === 0
        || duration === '0'
        || duration === null
        || duration === false;
    },
    onToast(e) {
      const { message, type, position, duration } = e.detail || {};
      this.message = message || 'Operación completada';
      this.type = type || 'success';
      this.position = position || 'bottom';
      this.visible = true;

      clearTimeout(this.timer);
      this.timer = null;

      if (!this.isSticky(duration)) {
        const ms = Number(duration) > 0 ? Number(duration) : 3500;
        this.timer = setTimeout(() => this.hide(), ms);
      }
    },
    hide() {
      this.visible = false;
      clearTimeout(this.timer);
      this.timer = null;
    }
  }
};
</script>

<style scoped>
.app-toast {
  position: fixed;
  z-index: 10050; /* arriba del navbar (z-index 1000) */
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  padding: 0.85rem 1.1rem;
  border-radius: 10px;
  font-size: 0.875rem;
  font-weight: 500;
  min-width: 280px;
  max-width: min(720px, calc(100vw - 2rem));
  max-height: min(70vh, 420px);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.2);
  color: #fff;
}

.app-toast--bottom {
  bottom: 1.5rem;
  right: 1.5rem;
}

/* Debajo del navbar fijo (56px), no encima/tapado */
.app-toast--top {
  top: calc(56px + 0.75rem);
  left: 50%;
  transform: translateX(-50%);
}

.app-toast--success { background: #22863a; }
.app-toast--danger  { background: #c0392b; }
.app-toast--warning { background: #d68910; }
.app-toast--info    { background: #1272c4; }

.app-toast > i {
  font-size: 1.05rem;
  flex-shrink: 0;
  margin-top: 0.1rem;
}

.app-toast-msg {
  flex: 1;
  line-height: 1.4;
  white-space: pre-line;
  overflow-y: auto;
  word-break: break-word;
}

.app-toast-close {
  background: rgba(255, 255, 255, 0.15);
  border: none;
  color: #fff;
  cursor: pointer;
  padding: 0.25rem 0.35rem;
  font-size: 0.85rem;
  flex-shrink: 0;
  line-height: 1;
  border-radius: 6px;
}
.app-toast-close:hover { background: rgba(255, 255, 255, 0.28); }

.toast-slide-enter-active.app-toast--top { animation: toast-in-top 0.25s ease-out; }
.toast-slide-leave-active.app-toast--top { animation: toast-in-top 0.2s ease-in reverse; }

.toast-slide-enter-active.app-toast--bottom { animation: toast-in-bottom 0.25s ease-out; }
.toast-slide-leave-active.app-toast--bottom { animation: toast-in-bottom 0.2s ease-in reverse; }

@keyframes toast-in-top {
  from { opacity: 0; transform: translateX(-50%) translateY(-12px); }
  to   { opacity: 1; transform: translateX(-50%) translateY(0); }
}

@keyframes toast-in-bottom {
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
}
</style>
